import React from 'react';
import { Container, ContainerBarra } from './styles';

interface ProgressBarInterface {
  percentage?: number;
}

const ProgressBar: React.FC<ProgressBarInterface> = ({ percentage = 0 }) => {
  return (
    <Container>
      <ContainerBarra porcentagem={percentage} />
    </Container>
  );
};

export default ProgressBar;
